import React, {useContext} from "react";
export const NodeOverlayContext = React.createContext({});

export function useNodePopover() {
    return useContext(NodeOverlayContext);
}